import { getConfig } from '@app/config';
import { NATIVE_TOKEN_ADDRESS } from '@thirdweb-dev/sdk';

export function getSymbol(symbol: string) {
  switch (symbol.toLowerCase()) {
    case 'weth': {
      return 'ETH';
    }
    default: {
      return symbol;
    }
  }
}

export function getTokenAddress(address: string, chainId: number | undefined) {
  const config = getConfig(chainId);

  switch (address.toLowerCase()) {
    case config?.CONTRACTS.WETH.toLowerCase(): {
      return NATIVE_TOKEN_ADDRESS;
    }
    default: {
      return address;
    }
  }
}
